import React from 'react';
import { FormattedMessage } from '@kyruus/intl';

import { ButtonLinkWithIcon, ButtonWithIcon } from '@kyruus/button';
import ArrowLeft2 from '@kyruus/react-ikons/ArrowLeft2';
import SortFilter from '@kyruus/react-ikons/SortFilter';

import { messages } from '../../lib/messages';
import {
  PROVIDER_DRAWER_OPEN,
  SORT_AND_FILTER_DRAWER_OPEN
} from '../../../machines/map-search/map-search-states';
import { OPEN_SORT_AND_FILTER } from '../../../machines/map-search/map-search-actions';
import {
  OPEN_MAPS_FILTER_DRAWER,
  CLICK_BACK_TO_LIST_VIEW_BUTTON
} from '../../lib/constants';
import { PositionRelativeWrapper, ListViewBtn, SortFilterBtn } from './styles';

function SortFilterListViewControls({
  history,
  log,
  backToSearchUrl,
  state,
  send,
  onFiltersOpened = () => {}
}) {
  const onOpenSortAndFilterButtonClick = () => {
    log(OPEN_MAPS_FILTER_DRAWER);
    send(OPEN_SORT_AND_FILTER);
    onFiltersOpened();
  };

  return (
    <PositionRelativeWrapper>
      {backToSearchUrl && (
        <ListViewBtn>
          <ButtonLinkWithIcon
            active={true}
            href={backToSearchUrl}
            mode="contrast"
            icon={<ArrowLeft2 size="11px" />}
            iconAlign="left"
            data-testid="BackToListView"
            onClick={(e) => {
              e.preventDefault();
              log(CLICK_BACK_TO_LIST_VIEW_BUTTON);
              history.push(backToSearchUrl);
            }}
          >
            <FormattedMessage {...messages.backToListView} />
          </ButtonLinkWithIcon>
        </ListViewBtn>
      )}
      {!state.matches(PROVIDER_DRAWER_OPEN) && (
        <SortFilterBtn>
          <ButtonWithIcon
            active={true}
            mode="contrast"
            icon={<SortFilter size="11px" />}
            data-testid="MapViewSortAndFilter"
            disabled={state.matches(SORT_AND_FILTER_DRAWER_OPEN)}
            onClick={onOpenSortAndFilterButtonClick}
          >
            <FormattedMessage {...messages.filterBtn} />
          </ButtonWithIcon>
        </SortFilterBtn>
      )}
    </PositionRelativeWrapper>
  );
}

export default SortFilterListViewControls;
